<template>
  <dx-modal id="modal-category-cost-center"
            :title="type === 'category' ? 'Categorias' : 'Centros de custo'"
            :value="show" @input="close">
    <div class="loading loading-lg" v-if="loading" />
    <template v-else>
      <div class="empty" v-if="items.length === 0">
        <div class="empty-icon">
          <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
        </div>
        <div class="empty-title h6">
          {{ type === 'category' ? 'Categorias' : 'Centros de custo' }}
        </div>
        <div class="empty-subtitle">
          <slot>Nenhum registro encontrado!</slot>
        </div>
      </div>
      <table class="table table-striped table-hover" v-else>
        <thead>
        <tr>
          <th>Descrição</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr class="c-hand" v-for="(item, i) in items" :key="i" @click="select(item)">
          <td>
            <span v-if="item.parent">{{ item.parent.name }} > </span>
            <strong>{{ item.name }}</strong>
          </td>
          <td class="text-right"><fa-icon :icon="['fal', 'chevron-right']" /></td>
        </tr>
        </tbody>
      </table>
    </template>
    <template slot="footer">
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    documentType: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  mounted() {
    if (this.type === 'category') {
      this.loadCategories();
    } else {
      this.loadCostCenters();
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    select(item) {
      this.$emit('selected', item);
    },
    loadCategories() {
      this.loading = true;
      const params = {
        active: true,
        allowsValue: true,
        type: this.documentType,
        limit: 0,
      };

      return this.$http.get('/categories', { params })
        .then(({ data }) => {
          this.items = data.items;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    loadCostCenters() {
      this.loading = true;
      const params = {
        active: true,
        allowsValue: true,
        limit: 0,
      };

      return this.$http.get('/cost-centers', { params })
        .then(({ data }) => {
          this.items = data.items;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
